module.exports = __webpack_public_path__ + "img/icon_home.efc1304f.c3a072b9.svg";